export default "__VITE_ASSET__Dvbe$KoD__"